import { axiosInstance } from './JsdhNotifikaceService';
import { handleRequest } from '../../axios';
import { ADMIN_TECHNIKA_OBSAZENI_NAHLED_URL, UDALOST_OBSAZENI_URL } from '../url';
import { ObsazeniNahledRequest, ObsazeniVysledek } from '../generated/models/Obsazeni';

export const getObsazeniNahled = (data: ObsazeniNahledRequest) =>
    handleRequest<ObsazeniVysledek>(() =>
        axiosInstance.post(ADMIN_TECHNIKA_OBSAZENI_NAHLED_URL, data)
    );

export const getObsazeniProPoplach = (poplachId: number) =>
    handleRequest<ObsazeniVysledek>(() =>
        axiosInstance.get(UDALOST_OBSAZENI_URL(poplachId))
    );
